import styled from '@emotion/styled';
import { css } from 'emotion';

import { getThemeColor } from '@ezugi/ui/theme';

const INPUT_SIZE = 24;
const TRACK_HEIGHT = 2;
const KNOB_SIZE = 14;

export const INDICATOR_COLOR = getThemeColor('accent');
export const TRACK_COLOR = '#848484';
const KNOB_COLOR = getThemeColor('foreground');

const centered = css`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
`;

const leftFloat = css`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  margin: auto;
`;

export const InputGroup = styled.div`
  position: relative;
  width: 100%;
  height: ${INPUT_SIZE}px;
  -webkit-overflow-scrolling: touch;
`;

export const Input = styled.input<{ knobSize?: number }>`
  opacity: 0 !important;
  user-select: none;
  width: 100%;
  height: 100%;
  ${centered};
  margin: auto;
  z-index: 1;
  -webkit-appearance: none;
  transform: translateZ(0);
  will-change: transform, opacity;


  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    pointer-events: none;
    appearance: none;
    width: ${({ knobSize = KNOB_SIZE }) => knobSize}px;
    height: ${({ knobSize = KNOB_SIZE }) => knobSize}px;
    background: ${KNOB_COLOR};
    cursor: pointer;
    border-radius: 50%;
    transition: background .3s, transform .3s;
    will-change: transform;
  }
  &::-moz-range-thumb {
    width: ${({ knobSize = KNOB_SIZE }) => knobSize}px;
    height: ${({ knobSize = KNOB_SIZE }) => knobSize}px;
    background: ${KNOB_COLOR};
    cursor: pointer;
    border-radius: 50%;
    transition: background .3s, transform .3s;
    will-change: transform;
  }
  &:focus {
    opacity: 1;
  }
  &:active::-webkit-slider-thumb {
    transform: scale(1.2);
    background: ${INDICATOR_COLOR};
  }
  &:active::-moz-range-thumb {
    transform: scale(1.2);
    background: ${INDICATOR_COLOR};
  }
`;

export const Indicator = styled.div`
  ${leftFloat};
  height: ${TRACK_HEIGHT}px;
  background-color: ${INDICATOR_COLOR};
`;

export const Knob = styled.div<{ knobSize?: number }>`
  ${leftFloat};
  width: ${({ knobSize = KNOB_SIZE }) => knobSize}px;
  height: ${({ knobSize = KNOB_SIZE }) => knobSize}px;
  border-radius: 50%;
  background-color: ${KNOB_COLOR};
  transform: translateX(-50%);
  will-change: transform;
`;

export const Track = styled.div<{ knobSize?: number }>`
  ${centered};
  width: 0;
  width: calc(100% - ${({ knobSize = KNOB_SIZE }) => knobSize}px);
  height: ${TRACK_HEIGHT}px;
  background-color: ${TRACK_COLOR};
`;

export const TrackLimits = styled.div`
  ${centered};
  width: 100%;
  height: ${TRACK_HEIGHT}px;

  display: flex;
  justify-content: space-between;
`;

export const TrackLimit = styled.div<{ knobSize?: number, color: string }>`
  width: ${({ knobSize = KNOB_SIZE }) => knobSize / 2}px;
  background-color: ${({ color }) => color};
`;
